import { render, staticRenderFns } from "./Queue.vue?vue&type=template&id=1b18633e"
import script from "./Queue.vue?vue&type=script&lang=js"
export * from "./Queue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports